import { Type } from "@angular/core";

export class DomainModel {
  public id: number;
  public name: string;
  public link: string;
  public description: string;
  public deleted: boolean;
  public pushScript: string;
  public type: number;
  public n: number;
  public blackout: number;
  public monetization: number;
}




// WEBPACK FOOTER //
// ./src/app/core/models/domain.model.ts